export const isServerApplicationInsightsClient = item => 'defaultClient' in item && 'constructor' in item.defaultClient && 'name' in item.defaultClient.constructor &&
// TODO: After applicationisights@3 is introduced this check must be udated
item.defaultClient.constructor.name === 'NodeClient';
//# sourceMappingURL=isServerApplicationInsightsClient.js.map